import { Schema } from 'yup';

export const getErrorMessage = async (schema: Schema<unknown>, value: unknown): Promise<string> => {
  let error = '';

  try {
    await schema.validate(value);
  } catch (e) {
    error = e.errors.pop();
  }

  return error;
};
